<div
  class="background-container d-flex justify-content-center flex-column align-items-center"
>
  <button class="btn primary-btn m-4" (click)="logout()">CERRAR SESIÓN</button>
  <img
    [src]="environment.serverFolder + '/assets/images/fit-factory-logo.png'"
    alt=""
    style="width: auto; height: 200px"
  />

  <div class="d-flex flex-column align-items-center mt-4">
    <span class="title yellow">ENTRENÁ CON</span>
    <span class="title">FIT FACTORY APP</span>
  </div>

  <span class="text-center subtitle"
    >Potenciá tus entrenamientos en el gimnasio con las herramientas
    inteligentes que diseñamos para vos</span
  >

  <button class="large-button m-4" [routerLink]="'/routines-tablet'">
    RUTINAS DEL DÍA <i class="bi bi-caret-right-fill"></i>
  </button>
  <button class="large-button m-4" [routerLink]="'/tutorials-tablet'">
    VIDEO TUTORIALES <i class="bi bi-caret-right-fill"></i>
  </button>
</div>
